import { UPDATE_CART_BEHAVIOR } from "../";

const defaultState = {
	linkType: "internal",
	link: "/cart",
	label: undefined,
};

const upselling = (state = null, action) => {
	switch (action.type) {
		case UPDATE_CART_BEHAVIOR:
			return {
				linkType: action.cartBehavior.linkType,
				link: action.cartBehavior.link,
				label: action.cartBehavior.label,
				suggestionType: action.cartBehavior.suggestionType,
				suggestionText: action.cartBehavior.suggestionText,
			};
		default:
			return state || defaultState;
	}
};

export default upselling;
